<template>
    <div :class="{'default-layout':true,'show-sidebar':showSidebar,'hidden-sidebar':!showSidebar}">


        <div class="sidebar-wrap">
            <fb-siderbar :collapse="!showSidebar" :appInfo="appInfo" :sidebarData="sidebarData"></fb-siderbar>
        </div>

        <div :class="{'content-wrap':true,'show-nav-tab':showNavTab,'hidden-nav-tab':!showNavTab}" >

            <div class="header-wrap" @click="switchNavTab">
                <fb-header>

                    <div slot="left">

                        <i :class="{'icon':true,'ion-md-menu':true,'ion-md-menu-vertical':!showSidebar}"
                           @click.stop="switchSidebar"></i>

<!--                        <el-breadcrumb class="breadcrumb" v-if="breadcrumb" >-->
<!--                            <el-breadcrumb-item v-for="(item,index) in breadcrumb" v-bind:key="index">{{item.name}}</el-breadcrumb-item>-->
<!--                        </el-breadcrumb>-->

                    </div>


                    <div slot="right">


                        <slot name="xxxx"></slot>

                        <div class="header-dropdown">
                            <i :class="{icon:true,'ion-md-expand':!isFullScreen,'ion-md-contract':isFullScreen}"
                               @click.stop="handleChangeFullScreen"></i>
                        </div>


                        <div v-if="showMessageCenter" class="header-dropdown">
                            <div @click="$emit('msgCenter')" style="position: relative;display: inline-block">
                                <i class="icon ion-ios-chatboxes"></i>
                                <span v-if="msgNum" style="background-color: rgb(234,64,20);border-radius: 50%;display: inline-block;width: 8px;height: 8px;position: absolute;top: 20px;"></span>
                            </div>
                        </div>


<!--                        <div class="header-dropdown language">-->
<!--                            <span class="language">语言</span>-->
<!--                            <i class="icon ion-md-arrow-dropdown"></i>-->

<!--                            <ul class="dropdown-list language-list">-->
<!--                                <li @click.stop="">简体中文</li>-->
<!--                                <li @click.stop="">繁体中文</li>-->
<!--                                <li @click.stop="">English</li>-->
<!--                            </ul>-->

<!--                        </div>-->

                        <div class="header-dropdown user-portrait">
                            <i class="icon ion-logo-github"></i>
                            <i class="icon ion-md-arrow-dropdown"></i>

                            <ul class="dropdown-list user-info">
                                <li @click.stop="$emit('userCenter')">User Center</li>
                                <li @click.stop="$emit('changePassword')">Change Password</li>
                                <li @click.stop="$emit('logout')">Logout</li>
                            </ul>

                        </div>

                    </div>

                </fb-header>
            </div>

            <div :class="{'main-body-wrap':true,'mb-hide-header':$route.meta.hideHeader}" >

                <slot name="main-body">
                    <fb-tab-view v-if="routeViewType === 'tab'" :show-nav-tab="showNavTab" ></fb-tab-view>
                    <tab-route-view v-if="routeViewType === 'route'"  ></tab-route-view>
                </slot>
            </div>

            <div  class="footer-wrap" >
                <fb-footer :appInfo="appInfo" ></fb-footer>
            </div>

        </div>

    </div>
</template>

<script>

    // import screenfull from 'screenfull';
    import TabRouteView from "fastboot-ui/src/components/tab-view/TabRouteView";

    export default {
        name: "DefaultLayout",
        props:{
            routeViewType:{
              type:String,
              default:function () {
                  return 'tab';
              }
            },
            appInfo:{
              type:Object,
              default:function () {
                  return {}
              }
            },showMessageCenter:{
                type:Boolean,
                default:function () {
                    return false
                }
            },msgNum:{
                type:Number,
                default:function () {
                    return 0
                }
            },
            sidebarData:{default:function () {
                    return this.sidebarDataDemo;
                }},
            userInfo:{type:Object,default:function () {
                    return {};
                }}
        },
        components: {TabRouteView},
        data() {
            return {
                showSidebar: true,
                showNavTab: true,
                isFullScreen: false,
                sidebarDataDemo: [
                    {
                        name: "组件概览",
                        icon: "icon ion-md-eye",
                        path: "/comp-preview",
                    },

                    {
                        name: "DEMO页面",
                        icon: "icon ion-md-filing",
                        path: "#",
                        children: [
                            {
                                name: "列表页",
                                icon: "",
                                path: "/list-body-demo",
                            },
                            {
                                name: "表单页",
                                icon: "",
                                path: "/form-body-demo"
                            }
                        ]
                    }
                ]
            }
        },
        watch: {},
        computed: {
            breadcrumb(){


                let url = this.$route.path;
                let ret = [];

                this.findMenu(url,menus,ret);

                if(ret.length){
                    return  ret.reverse();
                }else{
                    return null;
                }

            }
        },
        created() {

            let vm = this;

            if(window.routeViewType){
                vm.routeViewType = window.routeViewType;

                if(vm.routeViewType === 'route'){
                    vm.showNavTab = false;
                }

            }

        },
        methods: {
            findMenu(url,menus,ret){
                for(let i = 0; i < menus.length ; i++){

                    if(menus[i].url === url){

                        ret.push(menus[i]);
                        return true;
                    }else{


                        if(menus[i].children && this.findMenu(url,menus[i].children,ret)){
                            ret.push(menus[i]);
                            return  true;
                        }
                    }

                }

                return  false;

            },
            handleChangeFullScreen() {
                // if (screenfull.enabled) {
                //     screenfull.toggle();
                //     this.isFullScreen = !this.isFullScreen;
                // }
            },
            switchSidebar() {
                this.showSidebar = !this.showSidebar;
            },
            switchNavTab() {
                this.showNavTab = !this.showNavTab;
            }
        }
    }
</script>

<style lang="scss" scoped>


    /* 整体布局样式 */
    .default-layout {
        height: 100%;
    }

    /* 侧边栏布局样式 */
    .sidebar-wrap {
        height: 100%;
        background-color: #242C37;
        float: left;
    }

    /* 主体内容布局样式 */
    .content-wrap {
        height: 100%;
        background-color: azure;
        float: left;
        position: relative;
    }

    /* 头部布局样式 */
    .header-wrap {
        height: 64px;
        line-height: 64px;
        background-color: #ffffff;
        padding: 0 20px;
        position: relative;


        .icon {
            cursor: pointer;
        }

        .breadcrumb{
            display: inline-block;
            margin-left: 30px;
            vertical-align: middle
        }

        /* 侧边栏显示时切换按钮样式 */
        .ion-md-menu {
            display: inline-block;
            font-size: 26px;
            vertical-align: middle;
        }

        /* 侧边栏隐藏时切换按钮样式 */
        .ion-md-menu-vertical {
            display: inline-block;
            transform: rotate(90deg);
        }


        /* 头部下拉样式 */
        .header-dropdown {

            display: inline-block;
            margin-right: 16px;
            line-height: 64px;
            cursor: pointer;
            color: #515a6e;

            .icon {
                color: #515a6e;
            }

            &:last-child {
                margin-right: 0;
            }

        }


        .icon {
            font-size: 23px;
            display: inline-block;
            vertical-align: middle;
        }


        /* 语言切换下拉样式 */
        .language {
            display: inline-block;
            font-size: 12px;
            vertical-align: middle;

            &:hover {

                .language-list {
                    display: inline-block;
                    right: 60px;
                }

            }

        }


        /* 下拉小三角样式 */
        .ion-md-arrow-dropdown {
            padding-left: 8px;
            display: inline-block;
            vertical-align: middle;
            font-size: 18px;
        }


        /* 用户头像经过显示下拉列表样式 */
        .user-portrait:hover {
            .user-info {
                display: inline-block;
                width: 168px;
            }
        }


        /* 头部功能下拉列表样式 */
        .dropdown-list {
            display: none;
            padding: 0;
            margin: 0;
            position: absolute;
            right: 0;
            z-index: 99999;
            list-style: none;
            font-size: 12px;
            line-height: 12px;
            top: 50px;
            background-color: #ffffff;

            border: 1px solid #dcdfe6;

            border-bottom: none;

            li {
                border-bottom: 1px solid #dcdfe6;
                padding: 8px 20px;
                cursor: pointer;
            }

            li:hover {
                background-color: #dcdfe6;
            }


        }


    }


    /* 底部布局样式 */
    .footer-wrap {

        height: 64px;
        line-height: 64px;
        background-color: #ffffff;
        position: absolute;
        bottom: 0;
        width: 100%;
    }


    /* 显示侧边栏时布局样式 */
    .show-sidebar {

        .sidebar-wrap {
            width: 250px;
        }

        .content-wrap {
            width: calc(100% - 250px);
        }

        .main-body-wrap {
            height: calc(100% - 168px);

        }

    }


    /* 隐藏侧边栏时布局样式 */
    .hidden-sidebar {

        .sidebar-wrap {
            width: 64px;

        }

        .content-wrap {
            width: calc(100% - 64px);

        }

        .main-body-wrap {
            height: calc(100% - 152px);
        }
    }


    /* 隐藏标签栏时布局样式 */
    .hidden-nav-tab {

        .main-body-wrap {
            height: calc(100% - 192px);
        }

    }

    .mb-hide-header{
        height: calc(100% - 124px) !important;
    }


</style>
